<div>
  <h1 mat-dialog-title>Sign out</h1>
  <div mat-dialog-content>Are you sure you want to sign out?</div>
  <div align="end" mat-dialog-actions>
    <button mat-button mat-dialog-close>No</button>
    <button cdkFocusInitial color="warn" mat-dialog-close mat-raised-button (click)="clickedOK()">Yes</button>
  </div>
</div>
